import { HISTORICAL_APPLICATIONS_ACTION_TYPES } from '@constants/actionTypes/historicalApplicationActionTypes';
interface IAction {
    type: string;
    payload?: any;
}
export const INITIAL_STATE = {
    currentYear: '',
    historicalApplicationsBasicInfo: {
        firstName: '',
        lastName: '',
        dob: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        zipCode: '',
        emailId: '',
        phoneNumber: '',
        ssnLastFour: '',
        preferredContactMethod: '',
    },
    historicalApplicationsInfo: { 
        myApplications: [],
    },
    historicalEnrollmentsInfo: {
        enrollments: [],
    },
};
export default (state = INITIAL_STATE, action: IAction) => {
    switch (action?.type) {
        case HISTORICAL_APPLICATIONS_ACTION_TYPES.SET_CURRENT_YEAR: {
            return {
                ...state,
                currentYear: action.payload,
            };
        }
        case HISTORICAL_APPLICATIONS_ACTION_TYPES.SET_HISTORICAL_APPLICATIONS_BASIC_INFO: {
            return {
                ...state,
                historicalApplicationsBasicInfo: action.payload,
            };
        }
        case HISTORICAL_APPLICATIONS_ACTION_TYPES.SET_HISTORICAL_APPLICATIONS_INFO: {
            return {
                ...state,
                historicalApplicationsInfo: action.payload,
            };
        }
        case HISTORICAL_APPLICATIONS_ACTION_TYPES.SET_HISTORICAL_ENROLLMENTS_INFO: {
            return {
                ...state,
                historicalEnrollmentsInfo: action.payload,
            };
        }
        default:
            return state;
    }
};
